import { ColDef } from "ag-grid-community";
import {
  hierarchyAllItemsNameFilterValueGetter,
  hierarchyAllItemsNameValueGetter,
} from "@/components/pages/common/hierarchy-all-items/utils/helpers/valueGetters";
import { keyInsensitiveComparatorFn } from "@/components/pages/common/ag-grid/utils/helpers/sortingFunctions/keyInsensitiveComparatorFn";
import {
  PartialResourceExplorer,
  ReFolderWithChildren,
} from "@/components/pages/billing-explorer-all-views/components/table/utils/types/types";
import { hierarchyAllItemsColDef } from "@/components/pages/common/hierarchy-all-items/components/hierarchyAllItemsColDef";
import { BillingExplorerAllItemsActionCellRenderer } from "@/components/pages/billing-explorer-all-views/components/table/components/cells/BillingExplorerAllItemsActionCellRenderer";
import { BillingExplorerAllItemsNameInnerRenderer } from "@/components/pages/billing-explorer-all-views/components/table/components/cells/BillingExplorerAllItemsNameInnerRenderer";
import { agGridActionColumnDefaultColumnDef } from "@/components/pages/common/ag-grid/utils/constants/agGridActionColumnDefaultColumnDef";

export const billingExplorerAllItemsColumnDef: ColDef<
  PartialResourceExplorer | ReFolderWithChildren
> = {
  headerName: "Name",
  field: "name",
  minWidth: 300,
  suppressKeyboardEvent: () => true,
  cellRendererParams: {
    suppressCount: true,
    innerRenderer: BillingExplorerAllItemsNameInnerRenderer,
  },
  comparator: keyInsensitiveComparatorFn,
  valueGetter: hierarchyAllItemsNameValueGetter,
  filterValueGetter: hierarchyAllItemsNameFilterValueGetter,
};

export const billingExplorerAllItemsColDef: ColDef<
  PartialResourceExplorer | ReFolderWithChildren
>[] = [
  ...hierarchyAllItemsColDef,

  {
    ...agGridActionColumnDefaultColumnDef,
    colId: "actions",
    pinned: "right",
    maxWidth: 70,
    width: 70,
    minWidth: 70,
    cellDataType: false,
    cellRenderer: BillingExplorerAllItemsActionCellRenderer,
  } as ColDef,
];
